export const GET_BOT_CONFIG = {
  BEGIN: 'GET_BOT_CONFIG_BEGIN',
  SUCCESS: 'GET_BOT_CONFIG_SUCCESS',
  FAILURE: 'GET_BOT_CONFIG_FAILURE'
}
